import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '../../../context/AuthContext';
import { getPlatformAdminContext } from '../services/platformAdminService';

const PlatformAdminRoute: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  const {
    data,
    isLoading: isPlatformLoading,
    isError,
  } = useQuery({
    queryKey: ['platform-admin-context'],
    queryFn: getPlatformAdminContext,
    enabled: !isLoading && isAuthenticated,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading || isPlatformLoading) {
    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isError || !data?.is_platform_admin) {
    return <Navigate to="/margin-center/overview" replace />;
  }

  return <Outlet />;
};

export default PlatformAdminRoute;